import BusinessProfileModel from "models/business-profiles/BusinessProfile";
import { ProductKeys } from "containers/Pricing/products";
import { MicroBusinessProfileTypes } from "constants/Profiles";

const filterBusinessProfilesByCreator = (businessProfiles: BusinessProfileModel[]) =>
	businessProfiles.filter((businessProfile) => businessProfile.privileges.isCreator);

export const filterBusinessProfilesByProductKey = (
	businessProfiles: BusinessProfileModel[],
	typeOfProducts: ProductKeys,
) => {
	const businessProfileIamCreator = filterBusinessProfilesByCreator(businessProfiles);

	switch (typeOfProducts) {
		case ProductKeys.Elearnings:
			return businessProfileIamCreator.filter(
				(businessProfile) => businessProfile.info.type !== MicroBusinessProfileTypes.STARTUP,
			);
		case ProductKeys.Talents:
			return businessProfileIamCreator.filter(
				(businessProfile) =>
					![MicroBusinessProfileTypes.UNIVERSITY, MicroBusinessProfileTypes.ADVISER].includes(
						businessProfile.info.type,
					),
			);
		case ProductKeys.Challenges:
			return businessProfileIamCreator.filter(
				(businessProfile) =>
					![MicroBusinessProfileTypes.STARTUP, MicroBusinessProfileTypes.ADVISER].includes(businessProfile.info.type),
			);
	}
};
